import { createAsyncThunk } from '@reduxjs/toolkit';
import { isViewAsBuyerActive } from '../../../../utils/viewAsBuyer';

export const SaveSelectedOpportunity = createAsyncThunk(
    'marketplaceBuyers/SaveSelectedOpportunity',
    async (selectedOpportunityId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const currentSelectedOpportunityId =
            dispatch.getState().buyersState.targetBuyer.selectedOpportunityId;

        if (
            currentSelectedOpportunityId === selectedOpportunityId ||
            isViewAsBuyerActive()
        ) {
            return selectedOpportunityId;
        }

        try {
            const response = await axios.post(
                `/api/Marketplace/MarketplaceBuyers/selectedOpportunity/${selectedOpportunityId}`
            );

            if (response.status !== 200) {
                throw new Error('Failed to fetch buyers');
            }

            return selectedOpportunityId;
        } catch (error) {
            throw error;
        }
    }
);
